import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr.json';
import en from './locales/en.json';
import nl from './locales/nl.json';
import es from './locales/es.json';

const resources = {
  fr: { translation: fr },
  en: { translation: en },
  nl: { translation: nl },
  es: { translation: es },
};

// Nom du cookie partagé avec logfit-public (logfit.eu)
const LOCALE_COOKIE_NAME = 'LOGFIT_LOCALE';

// Helper pour définir le cookie avec le bon domaine
const setLocaleCookie = (locale: string) => {
  const isProduction = window.location.hostname.includes('logfit.eu');
  const domain = isProduction ? '.logfit.eu' : '';
  const maxAge = 365 * 24 * 60 * 60; // 1 an
  const secure = isProduction ? '; Secure' : '';

  document.cookie = `${LOCALE_COOKIE_NAME}=${locale}; path=/; max-age=${maxAge}; SameSite=Lax${domain ? `; domain=${domain}` : ''}${secure}`;
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en', 'nl', 'es'],

    detection: {
      // Ordre de détection : cookie partagé > localStorage > navigateur
      order: ['cookie', 'localStorage', 'navigator'],
      caches: ['localStorage', 'cookie'],
      lookupLocalStorage: 'i18nextLng',
      lookupCookie: LOCALE_COOKIE_NAME,
      cookieDomain: window.location.hostname.includes('logfit.eu') ? '.logfit.eu' : undefined,
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    react: {
      useSuspense: false,
    },
  });

// Écouter les changements de langue pour mettre à jour le cookie partagé
i18n.on('languageChanged', (lng) => {
  setLocaleCookie(lng);
});

export default i18n;
